const scrollNum = () => {
    const timers = document.querySelectorAll('.js-timer');
    if (!timers.length) return;

    const getDecimals = (value) => {
        const str = String(value);
        const decimalIndex = str.indexOf('.');
        return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
    };

    const isNumeric = (value) => {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };

    // 混合形式（例: "8:2"）をパースして数字と区切り文字に分解
    const parseMixedValue = (value) => {
        const parts = [];
        const regex = /(\d+\.?\d*)|([^\d.]+)/g;
        let match;
        while ((match = regex.exec(value)) !== null) {
            if (match[1]) {
                parts.push({ type: 'number', value: parseFloat(match[1]), original: match[1] });
            } else {
                parts.push({ type: 'separator', value: match[2] });
            }
        }
        return parts;
    };

    const countTo = (el) => {
        const toValue = el.dataset.to;
        const speed = parseFloat(el.dataset.speed) || 1000;
        const refreshInterval = parseFloat(el.dataset.refreshInterval) || 100;
        const useComma = el.classList.contains('js-count-number');

        // 純粋な数値の場合
        if (isNumeric(toValue)) {
            const from = parseFloat(el.dataset.from) || 0;
            const to = parseFloat(toValue);
            const decimals = el.dataset.decimals !== undefined
                ? parseInt(el.dataset.decimals, 10)
                : getDecimals(toValue);

            const loops = Math.ceil(speed / refreshInterval);
            const increment = (to - from) / loops;

            let value = from;
            let loopCount = 0;

            const format = (val) => {
                const fixed = val.toFixed(decimals);
                return useComma ? fixed.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',') : fixed;
            };

            el.textContent = format(value);

            const interval = setInterval(() => {
                value += increment;
                loopCount++;

                if (loopCount >= loops) {
                    value = to;
                    clearInterval(interval);
                }

                el.textContent = format(value);
            }, refreshInterval);

            return;
        }

        // 混合形式の場合（例: "8:2"）
        const parts = parseMixedValue(toValue);
        const numberParts = parts.filter(p => p.type === 'number');

        if (numberParts.length === 0) {
            el.textContent = toValue;
            return;
        }

        const loops = Math.ceil(speed / refreshInterval);
        let loopCount = 0;

        // 各数字パーツの増分を計算
        numberParts.forEach(part => {
            part.decimals = getDecimals(part.original);
            part.current = 0;
            part.increment = part.value / loops;
        });

        const formatOutput = () => {
            return parts.map(part => {
                if (part.type === 'separator') return part.value;
                const fixed = part.current.toFixed(part.decimals);
                return useComma ? fixed.replace(/\B(?=(?:\d{3})+(?!\d))/g, ',') : fixed;
            }).join('');
        };

        el.textContent = formatOutput();

        const interval = setInterval(() => {
            loopCount++;

            numberParts.forEach(part => {
                part.current += part.increment;
                if (loopCount >= loops) {
                    part.current = part.value;
                }
            });

            if (loopCount >= loops) {
                clearInterval(interval);
            }

            el.textContent = formatOutput();
        }, refreshInterval);
    };

    const findAnimeAncestor = (el) => {
        return el.closest('.js-anime');
    };

    timers.forEach((el) => {
        const ancestor = findAnimeAncestor(el);

        // 祖先にjs-animeがない、または既にis-animeが付いている場合は即実行
        if (!ancestor || ancestor.classList.contains('is-anime')) {
            countTo(el);
            return;
        }

        // is-animeが付与されるのを監視
        const observer = new MutationObserver(() => {
            if (ancestor.classList.contains('is-anime')) {
                countTo(el);
                observer.disconnect();
            }
        });

        observer.observe(ancestor, { attributes: true, attributeFilter: ['class'] });
    });
};

export default scrollNum;
